export const MODIFICAR_COTIZADOR = 'MODIFICAR_COTIZADOR';
export const CARGAR_NOTARIA = 'CARGAR_NOTARIA';
export const USER_LOADED = 'CARGAR_USUARIO';
export const ROLE_LOADED = 'CARGAR_ROL';